module.exports = __webpack_public_path__ + "static/img/yanganleft.1e701dc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeback/yanganleft.gif
// module id = furD
// module chunks = 1